import React from "react";

import styles from "./MidtermsTagStreamHeader.css";
import image from "assets/img/midterms.png";

export default function MidtermsTagStreamHeader() {
  return (
    <div className={styles.root}>
      <div className={styles.content}>
        <div className={styles.imgWrapper}>
          <img className={styles.img} src={image} />
        </div>
        <h2 className={styles.mainText}>2018 Midterm Elections</h2>
      </div>
    </div>
  );
}
